module.exports = __webpack_public_path__ + "img/logo-header.ee255019.png";